const ApiEndPoints = {
  uploadDoc:{
    url: "/api/upload-document",
    method:  "POST"
  }
};

export default ApiEndPoints;
